import { OfferCountLimit } from "@data-types/bet-booster/MostPlayedTickets";

export type Filter = {
	subscriptionId: string;
	shopId: string;
	/**
	 *  offerCount - optional parameter, only applies to mp tickets
	 * */
	offerCount?: OfferCountLimit;
	/**
	 *  if not set, both mp tickets and bb presets are returned; if 0 only bb presets, if 1 only mp tickets
	 */
	type?: Type;
	/**
	 * eventIds - optional parameter: if set only bb presets for those events are returned
	 */
	eventIds?: string[];
};

export enum Type {
	"bb-presets",
	"mp-tickets",
}
